<input
  type="text"
  class="form-control"
  (keyup)="onValueChanged($event)"
  (keydown.enter)="$event.preventDefault()"
  autocorrect="off"
  autocapitalize="off"
  spellcheck="off"
  type="text"
  (focusout)="onFocusOut()"
  #typeahead
  [ngbTypeahead]="lookupTypeahead"
  (selectItem)="onItemSelected($event)">
<app-loader *ngIf="searching" style="margin-top: -3px;"></app-loader>
